import React from "react";
import { motion } from "framer-motion";

export default function KpiStrip({ stats, lastScan }) {
  const items = [
    { label: "Active Signals", value: stats?.total ?? 0, testid: "kpi-total" },
    { label: "Fresh (3d)", value: stats?.fresh_today ?? 0, accent: "text-pos", testid: "kpi-fresh" },
    { label: "Short Term", value: stats?.short_term ?? 0, testid: "kpi-short" },
    { label: "Long Term", value: stats?.long_term ?? 0, testid: "kpi-long" },
    { label: "Target Hit", value: stats?.target_hit ?? 0, accent: "text-pos", testid: "kpi-target" },
    { label: "SL Hit", value: stats?.sl_hit ?? 0, accent: "text-neg", testid: "kpi-sl" },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-y border-subtle bg-surface"
      data-testid="kpi-strip"
    >
      {items.map((it, i) => (
        <div
          key={it.label}
          data-testid={it.testid}
          className={
            "p-4 md:p-5 border-r border-subtle last:border-r-0 " +
            (i < 3 ? "border-b md:border-b-0" : "")
          }
        >
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-fg mb-1">
            {it.label}
          </div>
          <div className={"font-mono text-2xl tabular-nums " + (it.accent || "text-primary-fg")}>
            {it.value}
          </div>
        </div>
      ))}
    </motion.div>
  );
}
